import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { map } from 'lodash'
import { useFormikContext } from 'formik'

import ServiceTypeItem from 'components/RevenueCenters/Form/ServiceTypeItem'

import { getServiceTypes } from 'store/ServiceTypes/selector'
import { editRevenueCenterSucceeded } from 'store/RevenueCenters/actions'

const ServiceTypes = ({ id }) => {
  const allMenusAssignedToRevenueCenter = useSelector(getServiceTypes)

  const { values } = useFormikContext()

  const history = useHistory()
  const dispatch = useDispatch()

  const handleSaveValues = () => {
    const {
      description,
      externalRefId,
      filterData,
      localTime,
      name,
      businessEndTime,
    } = values

    const editedRevenueCenterValues = {
      description,
      externalRefId,
      filterData,
      localTime,
      name,
      businessEndTime,
    }

    dispatch(editRevenueCenterSucceeded(editedRevenueCenterValues))
  }

  const onClickServiceType = () => {
    history.push(`${history.location.pathname}/add-service-type/new`)
    handleSaveValues()
  }

  return (
    <section>
      <h3 id={id} className="header-title">
        Service Types
      </h3>
      {map(
        allMenusAssignedToRevenueCenter,
        ({ uuid, displayName, serviceType }) => (
          <ServiceTypeItem
            key={uuid}
            uuid={uuid}
            displayName={displayName}
            serviceType={
              serviceType === 'Concessions' ? 'Pickup' : serviceType
            }
            handleSaveValues={handleSaveValues}
          />
        )
      )}

      <div className="content-wrapper -flags-wrapper">
        <button
          className="btn -outline -block"
          onClick={onClickServiceType}
          type="button"
        >
          Add a Service Type
        </button>
      </div>
    </section>
  )
}

export default ServiceTypes
